import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { noChange } from "lib/@hooks/useRefresh"
import { TranslationStateChanged } from "./translation-event-definitions.mjs"

const EMPTY_STATE = {
    loading: false,
    isTranslated: false,
    language: "en",
    rtl: false,
    error: null,
    translationMeta: null,
    labels: null,
    translatedSkills: null,
}

/**
 * Consumer hook for translation state. Re-renders the calling component
 * when TranslationStateChanged fires, WITHOUT triggering onChange bubbling
 * (uses noChange). Components that don't call this are completely unaffected
 * by translation state changes.
 *
 * @returns {{ loading: boolean, isTranslated: boolean, language: string, rtl: boolean, translationMeta: object|null, labels: object|null, translatedSkills: object|null }}
 */
export function useTranslationContext() {
    const { translationState } = useBoundContext()
    TranslationStateChanged.useRefresh(noChange)
    return translationState?.current ?? EMPTY_STATE
}
